import { useState } from "react";
import { motion } from "framer-motion";
import { KeyRound } from "lucide-react";
import { api, token, errMsg } from "../../lib/api";

export default function Gate({ onSuccess }) {
  const [passcode, setPasscode] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!passcode || busy) return;
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/studio/login", { passcode });
      token.set(data.token);
      onSuccess();
    } catch (err) {
      setError(errMsg(err, "Incorrect passcode — try again"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="studio-gate" className="min-h-screen grid place-items-center px-6">
      <motion.form
        onSubmit={submit}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-sm border border-line bg-panel p-8 md:p-10"
      >
        <div className="flex items-center gap-3 text-gold">
          <KeyRound size={16} />
          <p className="eyebrow !text-ochre/90">Private Studio</p>
        </div>
        <h1 className="font-display font-light text-3xl mt-4">Enter the atelier</h1>
        <p className="text-sm text-mute mt-3 leading-relaxed">
          This door is for the artist. Enter your passcode to manage the collection.
        </p>
        <input
          type="password"
          value={passcode}
          onChange={(e) => setPasscode(e.target.value)}
          placeholder="Passcode"
          data-testid="studio-passcode-input"
          className="field-input mt-8"
          autoFocus
        />
        {error && (
          <p className="font-meta text-[11px] text-red-400 mt-3" data-testid="studio-login-error">
            {error}
          </p>
        )}
        <button
          type="submit"
          disabled={busy || !passcode}
          data-testid="studio-login-button"
          className="mt-6 w-full border border-gold/60 bg-gold text-ink font-meta text-[11px] uppercase tracking-[0.3em] py-4 hover:bg-transparent hover:text-gold transition-colors duration-300 disabled:opacity-40 disabled:cursor-not-allowed"
        >
          {busy ? "Entering…" : "Enter"}
        </button>
      </motion.form>
    </div>
  );
}
